const CommonMenuIcon = (imgSrc) => () => {
    return <img src={imgSrc} alt="menu icon" width={16} height={16} />;
};

export default CommonMenuIcon;
